var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false, design: "v3" },
      on: { cancel: _vm.close },
    },
    [
      _c("div", { staticClass: "create-plan-information" }, [
        _c("div", { staticClass: "svg-banner" }, [_c("Discount")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "discount" }, [
          _vm._v("Yıllık alımlarda %20 indirim ile daha avantajlı ödeme."),
        ]),
        _vm._v(" "),
        _vm.planPeriod == "monthly"
          ? _c("div", { staticClass: "description" }, [
              _vm._v(
                "\n            Aylık planlar her ayın başında otomatik yenilenir ve faturalandırılır.\n            Aylık abonelikler iptal edilebilir ve değiştirilebilir; değişiklikler aynı gün içerisinde anlık olarak\n            yansır.\n        "
              ),
            ])
          : _c("div", { staticClass: "description" }, [
              _vm._v(
                "\n            Yıllık plan peşin olarak tahsil edilir ve iptal edilemez.\n            Daha yüksek bir pakete geçiş yapılabilir; sadece aradaki fiyat farkı alınır.\n        "
              ),
            ]),
        _vm._v(" "),
        _vm.isTrialMode
          ? _c("div", { staticClass: "trial-note" }, [
              _vm._v(
                "\n            Şu an deneme sürümündesiniz; bu süre boyunca ücret alınmaz. Deneme bittikten sonra\n            hizmeti kesintisiz kullanmaya devam etmek için kredi kartı eklemeniz gerekir. Kart ekledikten sonra,\n            seçtiğiniz planın ücretlendirme koşulları geçerli olacaktır.\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c(
              "SupsisButton",
              { staticClass: "footer-btn", on: { click: _vm.close } },
              [_vm._v("İptal")]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                staticClass: "footer-btn",
                attrs: { primary: "" },
                on: { click: _vm.confirm },
              },
              [
                _vm.loading
                  ? _c("a-icon", { attrs: { type: "loading" } })
                  : _c("span", [_vm._v("Satın Al")]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }